<template>
  <section class="event" js-page="event">
    <div class="event__wrapper">
      <Number :data="eventData.artwork" />
      <Title 
        :text="eventData.title"
        class="event__title"
      />
      <div class="event__details event__container">
        <Paragraph
          v-for="(paragraph, index) in eventData.paragraphs"
          :key="index"
          :text="paragraph"
        />
      </div>
      <div class="event__info event__container">
        <Details
          v-for="(info, key) in eventData.info"
          :key="key"
          :info="info"
          :title="key"
        />

        <div class="details details__mobile">
          <p class="details__title"><strong>{{ label[lang].info }}</strong></p><br>
          <p 
            class="details__text">
            {{ label[lang].phone }}: <a href="tel:+390309823338">+39 030 9823338</a><br>
            {{ label[lang].mail }}: <a href="mailto:festival@bersiserlini.it">festival@bersiserlini.it</a>
          </p>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { TweenLite, Power2 } from 'gsap/TweenMax';

import { qs, isMobile } from '@/scripts/utils';

import Title from '@/components/typo/Title';
import Paragraph from '@/components/typo/Paragraph';
import Details from '@/components/typo/Details';
import Number from '@/components/typo/Number';


export default {
  name: 'Event',

  components: {
    Title,
    Paragraph,
    Details,
    Number,
  },

  data() {
    return {
      isMobile,

      label: {
        it: {
          info: 'Info & prenotazioni',
          phone: 'Tel',
          mail: 'Mail',
        },
        en: {
          info: 'Info & booking',
          phone: 'Tel',
          mail: 'Mail',
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      eventData: 'getEventData',

      hoverEvent: 'getHoverEvent',

      lang: 'getLang',
    }),
  },

  mounted() {
    this.$el.style.opacity = 0;
    this.$store.commit('ADD_BUTTONS', qs('.event__btns'));

    this.$store.commit('SET_HOVEREVENT', this.eventData.artwork);
    if (isMobile()) TweenLite.to('.logo', 0.4, { autoAlpha: 0, ease: Power2.easeOut, delay: 0.2 });
  },
};
</script>

<style lang="scss" scoped>
@import '../application';

.event {
  position: relative;
  width: 100%;

  padding: 120px 0 150px 0;

  @include mq(sm) {
    padding: 0;
  }

  // @media (max-height: 650px) {
  //   padding: 120px 0 150px 0;
  // }

  -webkit-touch-callout: none;
  -webkit-user-select: none;
   -khtml-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;

  .event {
    &__wrapper {
      width: 100%;
      max-width: 100%;

      padding-top: 124px;

      @include mq(sm) {
        padding-top: 0;
        line-height: 1.25;
      }

      @include mq(lg) {
        max-width: 70%;
      }
    }

    &__container {
      max-width: 100%;

      @include mq(sm) {
        max-width: 50%;
      }

      @include mq(lg) {
        max-width: 640px;
      }
    }

    &__title {
      margin: 0 0 30px 0;

      @include mq(sm) {
        margin: 0 0 45px 0;
        line-height: 1.25;
      }

      @include mq(md) {
        margin: 0 0 30px 0;
      }

      @include mq(lg) {
        margin: 0 0 $margin*4 0;
        line-height: $font-lheight-default;
      }
    }

    &__details {
      margin: 0 0 $margin*2 0;

      @include mq(lg) {
        margin: 0 0 $margin*3 0;
      }
      p {
        line-height: 1.6;

        @include mq(lg) {
          font-size: 1.05rem;
        }
      }
    }
  }
  
  .event__title,
  .event__details,
  .event__info {
    @include mq($from: md) {
      padding-left: 30px;
    }
  }
}
</style>

<style lang="scss">
.event__wrapper {
  .js-splittedlines {
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Event.vue